var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{attrs:{"placeholder":"","disabled":_vm.schema.read},model:{value:(_vm.model[_vm.schema.model.split('.')[0]][_vm.schema.model.split('.')[1]]),callback:function ($$v) {_vm.$set(_vm.model[_vm.schema.model.split('.')[0]], _vm.schema.model.split('.')[1], $$v)},expression:"model[schema.model.split('.')[0]][schema.model.split('.')[1]]"}})
}
var staticRenderFns = []

export { render, staticRenderFns }